import React from 'react'
import "./Harsafe_Meet_Hero.css";
// import { Link } from "react-router-dom";
import HarsafeHeroHome from '../../../Img/harsafemeethero.png'

const SchoolMS_Hero = () => {
  return (
    <section className="hero_cover">
      <div className="container">
        <div className="hero_cover_content">
          <div className="row">
            <div className="col-sm-6">
              <div className="hero_cover_left">
                <div className="hero_cover_im">
                  {/* Insert image if needed */}
                </div>
                <h1 className="hero_cover_hd">
                  <span>Connect Seamlessly with Instant Communication Solutions</span>
                </h1>
                <h2>Introducing Harsafe Meet – Your Secure Chat Solution</h2>

                <div className="hero_cover_desc">
                  <p>Experience real-time, secure, and user-friendly communication with Harsafe Meet, designed for personal and professional connections with ease.</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="hero_cover_right">
              <div className="game_cover_img">
                  <img src={HarsafeHeroHome} alt="" />
                  
                  {/* Insert image if needed */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SchoolMS_Hero